module.exports = __webpack_public_path__ + "img/gift4-01-c05-t2.ccb36279.png";